import { defaultTheme } from '@eriksdigital/atomic-ui/styles';

export const theme = {
  ...defaultTheme,
  shape: {
    background: '#C4C4C4',
    backgroundInverse: '#ffffff',
  },
};
